export default __webpack_public_path__ + "static/media/image7.e0129415.jpg";